var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"position":"relative","height":"380px"}},[_c('Bar',{attrs:{"chart-options":_vm.chartOptions,"chart-data":_vm.chartData,"width":_vm.width,"height":_vm.height,"plugins":_vm.plugins}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }